import { API } from "@/api/config";

export default new (class Geotab {
  syncGeotabData(payload) {
    return API.ACCOUNTS.post("/business/geotab/sync", payload);
  }
})();
